import { OrdersDtoOrderLineDiscount, OrdersDtoOrderLineDto } from "@springtree/eva-services-core";
import { PrefigureDiscountsResponse } from "@springtree/eva-services-core/lib/eva-services-core";
import { useTranslations } from "next-intl";

import IconDiscount from "@/icons/icon-discount";
import cartUtils from "~/utils/cart-utils";
import intlUtils from "~/utils/intl-utils";

import styles from "../../cart/discount-product-tile.module.scss";
import Icon from "../../common/icon";
import PromoLabel from "../../common/promo-label";

type Props = {
  line: OrdersDtoOrderLineDto;
  prefiguredDiscounts: PrefigureDiscountsResponse;
  showNetPriceWithoutPromo?: boolean;
};

export default function GuestTrackYourOrderDiscountProductTile(props: Props) {
  const { line, prefiguredDiscounts, showNetPriceWithoutPromo } = props;
  const t = useTranslations();
  const priceFormatter = intlUtils.usePriceFormatter();
  const currency = line.CurrencyID;

  const promoLabelLocalized = (discount: OrdersDtoOrderLineDiscount) => {
    return prefiguredDiscounts?.Results && prefiguredDiscounts.Results.length > 0
      ? prefiguredDiscounts.Results.find((prefiguredDiscount) => prefiguredDiscount.DiscountID === discount.DiscountID)
          ?.MarketingDescription
      : undefined;
  };

  if (showNetPriceWithoutPromo) {
    return (
      <div className={styles.discountLines}>
        {line.Discounts?.filter(
          (discount) => discount.DiscountAmount !== undefined && discount.DiscountAmount !== 0
        ).map((discount) => (
          <div key={discount.DiscountID} className={styles.discountProductContainer}>
            <div className={styles.discountProductDescription}>
              <Icon icon={IconDiscount} width={16} height={16} />
              <span>{promoLabelLocalized(discount) || discount.Description}</span>
            </div>
            <span className={styles.discountProductAmount}>
              {priceFormatter.currency(discount.DiscountAmount, { currency: line.CurrencyID })}
            </span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={styles.discountLines}>
      {line.Discounts?.filter((discount) => discount.DiscountAmount !== undefined && discount.DiscountAmount !== 0).map(
        (discount) => (
          <div key={discount.DiscountID} className={styles.discountLine}>
            {cartUtils.isProductFree(line) ? (
              <div className={styles.nameWithLabel}>
                <p className={styles.name}>{promoLabelLocalized(discount) || discount.Description}</p>
                <PromoLabel text={t("generic.free")} />
              </div>
            ) : (
              <>
                <p className={styles.name}>{promoLabelLocalized(discount) || discount.Description}</p>
                <p className={styles.displayPrice}>{priceFormatter.currency(discount.DiscountAmount, { currency })}</p>
              </>
            )}
          </div>
        )
      )}
    </div>
  );
}
